import { Component } from '@angular/core';
import { SearchBaseCardComponent } from '../search-base-card.component';

@Component({
  selector: 'app-search-case-card',
  standalone: false,
  
  templateUrl: './search-case-card.component.html',
  styleUrl: './search-case-card.component.scss'
})
export class SearchCaseCardComponent extends SearchBaseCardComponent {

}
